// extracted by css-extract-rspack-plugin
export default {"presetActionList":"PresetsMenu-module__presetActionList___V6ix"};